export default {
    ESPONTANEA: 1,
    SAMU: 2,
    AMBULANCIA: 3,
    RENOVIAS: 4,
    INTERVIAS: 5,
    BOMBEIROS: 6,
}